(function () {
  function normalizeWhitespace(value) {
    return String(value || "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function decodeHtmlEntities(value) {
    if (!value) {
      return "";
    }

    var textarea = document.createElement("textarea");
    textarea.innerHTML = value;
    return textarea.value;
  }

  function getSellerHandle(search, defaultHandle) {
    var raw = String(search || "").replace(/^\?/, "").trim();
    var params = new URLSearchParams(raw);
    var handle =
      params.get("seller") ||
      params.get("store") ||
      params.get("handle") ||
      params.get("shop") ||
      "";

    if (!handle && raw) {
      var bareSegment = raw
        .split("&")
        .map(function (part) {
          return part.trim();
        })
        .find(function (part) {
          return part && part.indexOf("=") === -1;
        });

      if (bareSegment) {
        handle = bareSegment;
      }
    }

    return decodeURIComponent(handle || defaultHandle || "").trim();
  }

  function normalizeHandle(value) {
    return normalizeWhitespace(String(value || "").toLowerCase());
  }

  function getInitials(value, fallback) {
    var tokens = normalizeWhitespace(value)
      .split(" ")
      .filter(Boolean);

    if (!tokens.length) {
      return fallback || "";
    }

    return tokens
      .slice(0, 2)
      .map(function (token) {
        return token.charAt(0).toUpperCase();
      })
      .join("");
  }

  function extractSellerCity(addressValue) {
    var address = normalizeWhitespace(String(addressValue || ""));

    if (!address) {
      return "";
    }

    var normalizedAddress = address
      .replace(/\b\d{5}\b/g, " ")
      .replace(/\bIndonesia\b/gi, " ")
      .replace(/\s+/g, " ")
      .trim();

    if (!normalizedAddress) {
      return "";
    }

    var administrativeMatches = normalizedAddress.match(
      /\b(?:kota(?:\s+administrasi)?|kab(?:upaten)?\.?)\s+[A-Za-z.'-]+(?:\s+[A-Za-z.'-]+){0,3}/gi
    );

    if (administrativeMatches && administrativeMatches.length) {
      return normalizeWhitespace(
        administrativeMatches[administrativeMatches.length - 1].replace(/\.$/, "")
      );
    }

    var segments = normalizedAddress
      .split(/[;,]/)
      .map(function (segment) {
        return normalizeWhitespace(segment);
      })
      .filter(Boolean);

    if (segments.length > 1) {
      for (var index = segments.length - 1; index >= 0; index -= 1) {
        var segment = segments[index];

        if (!segment) {
          continue;
        }

        if (
          /\b(?:jalan|jl\.?|gang|gg\.?|blok|no\.?|nomor|rt|rw|kec\.?|kecamatan|kel\.?|kelurahan|desa|dusun|perum(?:ahan)?|ruko|rukan|tower|lantai)\b/i.test(
            segment
          )
        ) {
          continue;
        }

        return segment;
      }
    }

    var wordTokens = normalizedAddress
      .replace(/[^A-Za-zÀ-ÿ.' -]/g, " ")
      .split(/\s+/)
      .filter(Boolean);

    if (!wordTokens.length) {
      return "";
    }

    if (wordTokens.length === 1) {
      return wordTokens[0];
    }

    var tailToken = wordTokens[wordTokens.length - 1];
    var previousToken = wordTokens[wordTokens.length - 2];
    var thirdToken =
      wordTokens.length >= 3 ? wordTokens[wordTokens.length - 3] : "";
    var directionalTokens = ["utara", "selatan", "timur", "barat", "pusat"];
    var compoundLeadTokens = [
      "jakarta",
      "tangerang",
      "bandar",
      "kota",
      "kabupaten",
      "kab",
      "administrasi",
      "adm",
      "tanjung"
    ];

    if (
      directionalTokens.indexOf(String(tailToken || "").toLowerCase()) > -1 &&
      thirdToken &&
      compoundLeadTokens.indexOf(String(thirdToken || "").toLowerCase()) > -1
    ) {
      return [thirdToken, previousToken, tailToken].join(" ");
    }

    if (
      compoundLeadTokens.indexOf(String(previousToken || "").toLowerCase()) > -1 ||
      directionalTokens.indexOf(String(tailToken || "").toLowerCase()) > -1
    ) {
      return [previousToken, tailToken].join(" ");
    }

    return tailToken;
  }

  function createSvgPlaceholderDataUri(kind, label) {
    var safeLabel = normalizeWhitespace(label || "");

    if (kind === "avatar") {
      return (
        "data:image/svg+xml;charset=UTF-8," +
        encodeURIComponent(
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" fill="none">' +
            '<rect width="240" height="240" rx="120" fill="#F5F3ED"/>' +
            '<circle cx="120" cy="92" r="42" fill="#D8D3C7"/>' +
            '<path d="M58 195C58 160.758 85.758 133 120 133C154.242 133 182 160.758 182 195V204H58V195Z" fill="#D8D3C7"/>' +
          "</svg>"
        )
      );
    }

    return (
      "data:image/svg+xml;charset=UTF-8," +
      encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 240 240" fill="none">' +
          '<rect width="240" height="240" rx="48" fill="#FFF7F1"/>' +
          '<rect x="12" y="12" width="216" height="216" rx="40" fill="#FFFFFF" stroke="#F1E6DA" stroke-width="4"/>' +
          '<text x="120" y="132" text-anchor="middle" font-family="Arial, sans-serif" font-size="72" font-weight="700" fill="#D3543F">' +
            safeLabel.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;") +
          "</text>" +
        "</svg>"
      )
    );
  }

  function parseJsonArray(node) {
    if (!node) {
      return [];
    }

    try {
      var parsed = JSON.parse(node.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function mergeSellerEntry(current, next) {
    var merged = Object.assign({}, current || {});

    Object.keys(next || {}).forEach(function (key) {
      var value = next[key];

      if (value === undefined || value === null) {
        return;
      }

      if (typeof value === "string" && normalizeWhitespace(value) === "") {
        return;
      }

      merged[key] = value;
    });

    return merged;
  }

  function getLocalSellerDirectory(element) {
    if (element.__sellerDirectory) {
      return element.__sellerDirectory;
    }

    var builtIns = parseJsonArray(
      element.querySelector("[data-seller-directory-builtins]")
    );
    var overrides = parseJsonArray(
      element.querySelector("[data-seller-directory-overrides]")
    );
    var directory = {};

    builtIns.concat(overrides).forEach(function (entry) {
      var handle = normalizeHandle(entry && entry.handle);
      if (!handle) {
        return;
      }

      directory[handle] = mergeSellerEntry(directory[handle], entry);
      directory[handle].handle = handle;
    });

    element.__sellerDirectory = directory;
    return directory;
  }

  function resolveShopDomain(element) {
    var override = normalizeWhitespace(element.dataset.shopDomainOverride || "");
    if (override) {
      return override;
    }

    var myshopifyDomain = normalizeWhitespace(
      element.dataset.shopMyshopifyDomain || ""
    );
    if (myshopifyDomain) {
      return myshopifyDomain;
    }

    return normalizeWhitespace(element.dataset.shopPermanentDomain || "");
  }

  function resolvePublicProfileApiBaseUrl(element) {
    return normalizeWhitespace(element.dataset.publicProfileApiBaseUrl || "").replace(
      /\/+$/,
      ""
    );
  }

  function uniqueCallbackName(prefix) {
    return [prefix, Date.now(), Math.round(Math.random() * 100000)].join("_");
  }

  function requestJsonp(url, callbackName) {
    return new Promise(function (resolve, reject) {
      var timedOut = false;
      var script = document.createElement("script");
      var timeout = window.setTimeout(function () {
        timedOut = true;
        cleanup();
        reject(new Error("jsonp_timeout"));
      }, 15000);

      function cleanup() {
        window.clearTimeout(timeout);
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
        try {
          delete window[callbackName];
        } catch (error) {
          window[callbackName] = undefined;
        }
      }

      window[callbackName] = function (payload) {
        if (timedOut) {
          return;
        }
        cleanup();
        resolve(payload);
      };

      script.async = true;
      script.src = url;
      script.onerror = function () {
        cleanup();
        reject(new Error("jsonp_failed"));
      };

      document.head.appendChild(script);
    });
  }

  function parseHtmlDocument(html) {
    return new window.DOMParser().parseFromString(html, "text/html");
  }

  function stripUnsafeNodes(container) {
    if (!container) {
      return "";
    }

    Array.from(container.querySelectorAll("script, style, link, iframe")).forEach(
      function (node) {
        node.remove();
      }
    );

    return container.innerHTML.trim();
  }

  function extractText(doc, selector) {
    var node = doc.querySelector(selector);
    return normalizeWhitespace(node ? node.textContent : "");
  }

  function extractInfoRowValue(text, label, fallback) {
    var pattern = new RegExp(label + "\\s*([^|]+)", "i");
    var match = String(text || "").match(pattern);
    if (!match) {
      return fallback || "";
    }

    return normalizeWhitespace(match[1]) || fallback || "";
  }

  function isPlaceholderOwnerImage(url) {
    return /icon-user\.png/i.test(String(url || ""));
  }

  function extractOwnerName(doc) {
    var ownerPanel = doc.querySelector(".wk-seller-profile");
    if (!ownerPanel) {
      return "";
    }

    var textNodes = Array.from(ownerPanel.querySelectorAll("div"))
      .map(function (element) {
        return normalizeWhitespace(element.textContent);
      })
      .filter(function (value) {
        return value && !/shop owner/i.test(value);
      });

    return textNodes[textNodes.length - 1] || "";
  }

  function extractVendorName(profileHtml, doc) {
    var match = String(profileHtml || "").match(/sellerUniqueId\.value = "([^"]+)"/i);
    if (match && normalizeWhitespace(match[1])) {
      return normalizeWhitespace(match[1]);
    }

    return (
      extractText(doc, ".mp-store-name span") ||
      extractText(doc, ".mp-store-name") ||
      ""
    );
  }

  function buildProfileData(profileHtml, element) {
    var doc = parseHtmlDocument(profileHtml);
    var infoRows = Array.from(doc.querySelectorAll(".mp-color-gray.mp-mrgn-btm-5"));
    var joinInfoText =
      infoRows
        .map(function (row) {
          return normalizeWhitespace(row.textContent);
        })
        .find(function (value) {
          return /Join Since|Total Products|Total Sale/i.test(value);
        }) || "";

    var shortDescriptionHtml = stripUnsafeNodes(
      doc.querySelector(".mp-store-short-desc")
    );
    var policyHtml = stripUnsafeNodes(doc.querySelector("#seller_policy"));
    var descriptionHtml = stripUnsafeNodes(doc.querySelector("#seller_description"));
    var storeLogoUrl = doc.querySelector("#shop_logo_image")
      ? doc.querySelector("#shop_logo_image").getAttribute("src")
      : "";
    var ownerImageUrl = doc.querySelector("#store_logo_image")
      ? doc.querySelector("#store_logo_image").getAttribute("src")
      : "";
    var fallbackOwnerImage = element.dataset.fallbackOwnerImage || "";
    var fallbackOwnerName = element.dataset.fallbackOwnerName || "";

    if (isPlaceholderOwnerImage(ownerImageUrl) && fallbackOwnerImage) {
      ownerImageUrl = fallbackOwnerImage;
    }

    return {
      bannerUrl: doc.querySelector(".mp-banner-container img")
        ? doc.querySelector(".mp-banner-container img").getAttribute("src")
        : "",
      storeLogoUrl: storeLogoUrl || "",
      storeName:
        extractText(doc, ".mp-store-name span") ||
        extractText(doc, ".mp-store-name") ||
        "Seller Store",
      shortDescriptionHtml: shortDescriptionHtml || "",
      address:
        extractText(doc, ".mp-location") ||
        extractInfoRowValue(joinInfoText, "Address", ""),
      joinSince: extractInfoRowValue(joinInfoText, "Join Since", "Belum tersedia"),
      totalProducts: extractInfoRowValue(joinInfoText, "Total Products", ""),
      totalSales: extractInfoRowValue(
        joinInfoText,
        "Total Sale",
        element.dataset.fallbackTotalSales || "Belum tersedia"
      ),
      ownerName:
        extractOwnerName(doc) ||
        fallbackOwnerName ||
        extractText(doc, ".mp-store-name span") ||
        "Shop Owner",
      ownerImageUrl: ownerImageUrl || "",
      vendorName: extractVendorName(profileHtml, doc),
      policyHtml: policyHtml || "<p>Policy seller belum tersedia.</p>",
      descriptionHtml:
        descriptionHtml ||
        shortDescriptionHtml ||
        "<p>Deskripsi seller belum tersedia.</p>"
    };
  }

  function buildLocalProfileData(entry, element) {
    var fallbackOwnerImage = element.dataset.fallbackOwnerImage || "";
    var fallbackOwnerName = element.dataset.fallbackOwnerName || "";
    var storeName = normalizeWhitespace(entry.storeName || entry.vendorName || "");
    var storeLogoUrl = normalizeWhitespace(entry.storeLogoUrl || "");
    var ownerName = normalizeWhitespace(entry.ownerName || entry.sellerName || "");
    var ownerImageUrl =
      normalizeWhitespace(entry.ownerImageUrl || "") || fallbackOwnerImage;
    var shortDescriptionHtml = entry.shortDescriptionHtml || "";
    var descriptionHtml = entry.descriptionHtml || shortDescriptionHtml;

    return {
      bannerUrl: normalizeWhitespace(entry.bannerUrl || ""),
      storeLogoUrl: storeLogoUrl,
      storeName: storeName || "Seller Store",
      shortDescriptionHtml: shortDescriptionHtml,
      address: normalizeWhitespace(entry.address || ""),
      joinSince: normalizeWhitespace(entry.joinSince || "") || "Belum tersedia",
      totalProducts: normalizeWhitespace(entry.totalProducts || ""),
      totalSales:
        normalizeWhitespace(entry.totalSales || "") ||
        element.dataset.fallbackTotalSales ||
        "Belum tersedia",
      ownerName:
        ownerName || fallbackOwnerName || "Shop Owner",
      ownerImageUrl: ownerImageUrl,
      vendorName:
        normalizeWhitespace(entry.vendorName || "") ||
        storeName ||
        "",
      policyHtml:
        entry.policyHtml || "<p>Policy seller belum tersedia.</p>",
      descriptionHtml:
        descriptionHtml || "<p>Deskripsi seller belum tersedia.</p>"
    };
  }

  function buildVendorCollectionUrl(vendorName, pageUrl, sortValue) {
    sortValue = normalizeWhitespace(sortValue || "");
    var requestUrl = pageUrl;

    if (!requestUrl) {
      requestUrl = "/collections/vendors?q=" + encodeURIComponent(vendorName);
    }

    var url = new URL(requestUrl, window.location.origin);

    if (!sortValue || sortValue === "default" || isExpirySortValue(sortValue)) {
      url.searchParams.delete("sort_by");
    } else {
      url.searchParams.set("sort_by", sortValue);
    }

    return url.pathname + url.search + url.hash;
  }

  function getCurrentSortValue(element) {
    return normalizeWhitespace(element.dataset.currentSortValue || "default") || "default";
  }

  function isExpirySortValue(sortValue) {
    return (
      sortValue === "expired-date-asc" || sortValue === "expired-date-desc"
    );
  }

  function parseExpiryDateValue(item) {
    var expiryValue = normalizeWhitespace(
      item && item.getAttribute("data-expired-date")
    );

    if (!expiryValue) {
      return null;
    }

    var expiryTime = Date.parse(expiryValue + "T00:00:00");
    return Number.isFinite(expiryTime) ? expiryTime : null;
  }

  function syncSortSelect(element) {
    var sortSelect = element.querySelector("[data-seller-product-sort]");
    if (!sortSelect) {
      return;
    }

    sortSelect.value = getCurrentSortValue(element);
  }

  function applyProductSort(element) {
    var sortValue = getCurrentSortValue(element);
    var itemsContainer = element.querySelector(
      "[data-product-grid-host] [data-productgrid-items]"
    );

    if (!itemsContainer || !isExpirySortValue(sortValue)) {
      return;
    }

    var productItems = Array.prototype.slice.call(
      itemsContainer.querySelectorAll("[data-product-item]")
    );

    if (productItems.length < 2) {
      return;
    }

    productItems
      .sort(function (firstItem, secondItem) {
        var firstDate = parseExpiryDateValue(firstItem);
        var secondDate = parseExpiryDateValue(secondItem);

        if (firstDate === null && secondDate === null) {
          return 0;
        }

        if (firstDate === null) {
          return 1;
        }

        if (secondDate === null) {
          return -1;
        }

        if (sortValue === "expired-date-desc") {
          return secondDate - firstDate;
        }

        return firstDate - secondDate;
      })
      .forEach(function (productItem) {
        itemsContainer.appendChild(productItem);
      });
  }

  function parseProductCount(responseText, doc) {
    var script = doc.querySelector("[data-section-data]");
    if (script) {
      try {
        var parsed = JSON.parse(script.textContent);
        if (Number.isFinite(Number(parsed.product_count))) {
          return Number(parsed.product_count);
        }
      } catch (error) {
        // no-op
      }
    }

    var match = String(responseText || "").match(/"product_count"\s*:\s*(\d+)/i);
    return match ? Number(match[1]) : null;
  }

  function fetchVendorCollection(vendorName, pageUrl, sortValue) {
    var requestUrl = buildVendorCollectionUrl(vendorName, pageUrl, sortValue);

    return window
      .fetch(requestUrl, {
        credentials: "same-origin"
      })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("vendor_collection_failed");
        }

        return response.text();
      })
      .then(function (responseText) {
        var doc = parseHtmlDocument(responseText);
        var items = doc.querySelector(".productgrid--items");
        var noResults = doc.querySelector(".productgrid--no-results");
        var pagination = doc.querySelector(".pagination--container");
        var productCount = parseProductCount(responseText, doc);
        var collectionTitle = extractText(doc, ".collection--title");

        return {
          requestUrl: requestUrl,
          productCount: productCount,
          collectionTitle: collectionTitle,
          itemsHtml: items ? items.outerHTML : "",
          noResultsHtml: noResults ? noResults.outerHTML : "",
          paginationHtml: pagination ? pagination.outerHTML : ""
        };
      });
  }

  function setImage(container, image, url, emptyLabel, placeholderUrl) {
    var finalUrl =
      normalizeWhitespace(url || "") || normalizeWhitespace(placeholderUrl || "");
    var normalizedPlaceholder = normalizeWhitespace(placeholderUrl || "");

    container.classList.remove("is-empty");
    container.removeAttribute("data-empty-label");

    if (image.parentNode !== container) {
      container.appendChild(image);
    }

    image.removeAttribute("srcset");
    image.removeAttribute("hidden");
    image.onerror = null;

    if (!finalUrl) {
      image.setAttribute("hidden", "hidden");
      image.removeAttribute("src");
      container.classList.add("is-empty");

      if (emptyLabel) {
        container.setAttribute("data-empty-label", emptyLabel);
      }

      return;
    }

    image.onerror = function () {
      image.onerror = null;

      if (normalizedPlaceholder && finalUrl !== normalizedPlaceholder) {
        image.src = normalizedPlaceholder;
        return;
      }

      image.setAttribute("hidden", "hidden");
      image.removeAttribute("src");
      container.classList.add("is-empty");

      if (emptyLabel) {
        container.setAttribute("data-empty-label", emptyLabel);
      }
    };

    image.src = finalUrl;
  }

  function setHtml(target, html, fallbackText) {
    if (!target) {
      return;
    }

    if (!normalizeWhitespace(target.textContent) && !html && fallbackText) {
      target.innerHTML = "<p>" + fallbackText + "</p>";
      return;
    }

    if (html) {
      target.innerHTML = html;
      return;
    }

    target.innerHTML = fallbackText ? "<p>" + fallbackText + "</p>" : "";
  }

  function formatCount(value) {
    var numeric = Number(value);
    if (!Number.isFinite(numeric)) {
      return value || "0";
    }

    return new Intl.NumberFormat("id-ID").format(numeric);
  }

  function createWebkulProfileUrl(shopDomain, sellerHandle) {
    var callbackName = uniqueCallbackName("sellerProfileCallback");
    var params = new URLSearchParams({
      callback: callbackName,
      p: "vc_seller_profile",
      shop: shopDomain,
      seller: sellerHandle,
      is_preview: "0",
      customer_id: "",
      bt_enabled: "0",
      selected_tag: "",
      customer_email: ""
    });

    return {
      callbackName: callbackName,
      url: "https://sp-seller.webkul.com/index.php?" + params.toString()
    };
  }

  function createPublicProfileUrl(baseUrl, sellerHandle, sellerId) {
    var callbackName = uniqueCallbackName("sellerPublicProfileCallback");
    var params = new URLSearchParams({
      callback: callbackName
    });

    if (sellerHandle) {
      params.set("seller", sellerHandle);
    }

    if (sellerId) {
      params.set("seller_id", sellerId);
    }

    return {
      callbackName: callbackName,
      url: baseUrl + "/public/seller-profile?" + params.toString()
    };
  }

  function requestPublicSellerProfile(baseUrl, sellerHandle, sellerId) {
    if (!baseUrl || (!sellerHandle && !sellerId)) {
      return Promise.reject(new Error("public_profile_api_unavailable"));
    }

    var request = createPublicProfileUrl(baseUrl, sellerHandle, sellerId);

    return requestJsonp(request.url, request.callbackName).then(function (payload) {
      if (!payload || payload.ok !== true || !payload.data) {
        throw new Error(
          (payload && payload.error) || "public_profile_response_invalid"
        );
      }

      return payload.data;
    });
  }

  function buildPublicProfileEntry(payload) {
    if (!payload || typeof payload !== "object") {
      return {};
    }

    return {
      handle: normalizeHandle(payload.handle || ""),
      sellerId: normalizeWhitespace(payload.sellerId || ""),
      storeName: normalizeWhitespace(payload.storeName || ""),
      sellerName: normalizeWhitespace(payload.sellerName || ""),
      bannerUrl: normalizeWhitespace(payload.bannerUrl || ""),
      storeLogoUrl: normalizeWhitespace(payload.storeLogoUrl || ""),
      shortDescriptionHtml: payload.shortDescriptionHtml || "",
      address: normalizeWhitespace(payload.address || ""),
      totalProducts: normalizeWhitespace(payload.totalProducts || ""),
      totalSales: normalizeWhitespace(payload.totalSales || ""),
      joinSince: normalizeWhitespace(payload.joinSince || ""),
      ownerName: normalizeWhitespace(payload.ownerName || payload.sellerName || ""),
      ownerImageUrl: normalizeWhitespace(payload.ownerImageUrl || ""),
      policyHtml: payload.policyHtml || "",
      descriptionHtml: payload.descriptionHtml || "",
      source: normalizeWhitespace(payload.source || "public_profile_api")
    };
  }

  function activateTab(element, panelId) {
    var tabs = element.querySelectorAll("[data-seller-profile-tab]");
    var panels = element.querySelectorAll("[data-seller-profile-panel]");

    tabs.forEach(function (tab) {
      var isActive = tab.getAttribute("data-seller-profile-tab") === panelId;
      tab.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    panels.forEach(function (panel) {
      var isActive = panel.id === panelId;
      panel.classList.toggle("is-active", isActive);
    });
  }

  function initialiseTabs(element) {
    element.addEventListener("click", function (event) {
      var button = event.target.closest("[data-seller-profile-tab]");
      if (!button) {
        return;
      }

      activateTab(element, button.getAttribute("data-seller-profile-tab"));
    });
  }

  function renderProfile(element, profileData) {
    var bannerContainer = element.querySelector("[data-store-banner]");
    var bannerImage = element.querySelector("[data-store-banner-image]");
    var storeLogoContainer = element.querySelector("[data-store-logo]");
    var storeLogoImage = element.querySelector("[data-store-logo-image]");
    var ownerImageContainer = element.querySelector("[data-owner-image]");
    var ownerImage = element.querySelector("[data-owner-image-node]");

    setImage(bannerContainer, bannerImage, profileData.bannerUrl, "");
    setImage(
      storeLogoContainer,
      storeLogoImage,
      profileData.storeLogoUrl,
      getInitials(profileData.storeName, "Logo"),
      createSvgPlaceholderDataUri(
        "logo",
        getInitials(profileData.storeName, "S")
      )
    );
    setImage(
      ownerImageContainer,
      ownerImage,
      profileData.ownerImageUrl,
      getInitials(profileData.ownerName, "Owner"),
      createSvgPlaceholderDataUri("avatar", "")
    );

    var displayCity = extractSellerCity(profileData.address);

    element.querySelector("[data-store-name]").textContent = profileData.storeName;
    element.querySelector("[data-store-address]").textContent =
      displayCity || "Alamat seller belum tersedia";
    element.querySelector("[data-owner-name]").textContent = profileData.ownerName;
    element.querySelector("[data-join-since]").textContent = profileData.joinSince;
    setHtml(
      element.querySelector("[data-store-short-description]"),
      profileData.shortDescriptionHtml,
      "Deskripsi singkat seller belum tersedia."
    );
    setHtml(
      element.querySelector("[data-policy-content]"),
      profileData.policyHtml,
      "Policy seller belum tersedia."
    );
    setHtml(
      element.querySelector("[data-description-content]"),
      profileData.descriptionHtml,
      "Deskripsi seller belum tersedia."
    );
  }

  function renderProductGrid(element, vendorPayload, vendorName) {
    var gridHost = element.querySelector("[data-product-grid-host]");
    var paginationHost = element.querySelector("[data-product-pagination]");
    var statusNode = element.querySelector("[data-product-status]");
    var summaryNode = element.querySelector("[data-product-summary]");
    var totalProductsNode = element.querySelector("[data-total-products]");
    var viewAllLink = element.querySelector("[data-view-all-products]");

    var countLabel = Number.isFinite(Number(vendorPayload.productCount))
      ? formatCount(vendorPayload.productCount)
      : "0";

    totalProductsNode.textContent = countLabel;
    summaryNode.innerHTML =
      "<strong>" +
      countLabel +
      "</strong> produk dari seller ini ditampilkan dengan layout collection theme.";

    if (viewAllLink) {
      viewAllLink.href = buildVendorCollectionUrl(vendorName);
    }

    element.dataset.currentVendorRequestUrl =
      vendorPayload.requestUrl || buildVendorCollectionUrl(vendorName);

    if (vendorPayload.itemsHtml) {
      gridHost.innerHTML = vendorPayload.itemsHtml;
      applyProductSort(element);
      statusNode.classList.remove("is-empty");
      statusNode.textContent = "";
    } else if (vendorPayload.noResultsHtml) {
      gridHost.innerHTML = vendorPayload.noResultsHtml;
      statusNode.classList.add("is-empty");
      statusNode.textContent = "Produk seller belum tersedia.";
    } else {
      gridHost.innerHTML = "";
      statusNode.classList.add("is-empty");
      statusNode.textContent = "Produk seller belum tersedia.";
    }

    paginationHost.innerHTML = vendorPayload.paginationHtml || "";

    if (gridHost.innerHTML) {
      window.requestAnimationFrame(function () {
        gridHost.dispatchEvent(
          new CustomEvent("theme:rimg:watch", {
            bubbles: true
          })
        );
      });
    }
  }

  function loadVendorPage(element, vendorName, pageUrl) {
    var statusNode = element.querySelector("[data-product-status]");
    var currentSortValue = getCurrentSortValue(element);
    statusNode.classList.remove("is-empty");
    statusNode.textContent = "Memuat daftar produk seller...";

    return fetchVendorCollection(vendorName, pageUrl, currentSortValue)
      .then(function (payload) {
        renderProductGrid(element, payload, vendorName);       
      })
      .catch(function () {
        var gridHost = element.querySelector("[data-product-grid-host]");
        var paginationHost = element.querySelector("[data-product-pagination]");
        var totalProductsNode = element.querySelector("[data-total-products]");

        gridHost.innerHTML = "";
        paginationHost.innerHTML = "";
        totalProductsNode.textContent =
          totalProductsNode.textContent || "0";
        statusNode.classList.add("is-empty");
        statusNode.textContent =
          "Produk seller tidak dapat dimuat saat ini. Silakan coba lagi.";
      });
  }

  function initialisePagination(element) {
    if (element.dataset.paginationInitialised === "true") {
      return;
    }

    element.dataset.paginationInitialised = "true";
    var paginationHost = element.querySelector("[data-product-pagination]");
    paginationHost.addEventListener("click", function (event) {
      var link = event.target.closest("a[href]");
      if (!link) {
        return;
      }

      event.preventDefault();
      loadVendorPage(element, element.dataset.currentVendorName || "", link.href);
    });
  }

  function initialiseProductSort(element) {
    var sortSelect = element.querySelector("[data-seller-product-sort]");
    if (!sortSelect || element.dataset.sortInitialised === "true") {
      return;
    }

    element.dataset.sortInitialised = "true";
    element.dataset.currentSortValue = getCurrentSortValue(element);
    syncSortSelect(element);

    sortSelect.addEventListener("change", function () {
      var sortValue =
        normalizeWhitespace(sortSelect.value || "default") || "default";
      var vendorName = element.dataset.currentVendorName || "";
      var currentPageUrl =
        element.dataset.currentVendorRequestUrl || "";

      element.dataset.currentSortValue = sortValue;
      syncSortSelect(element);

      if (!vendorName) {
        return;
      }

      if (sortValue === "default") {
        loadVendorPage(element, vendorName, currentPageUrl);
        return;
      }

      if (
        isExpirySortValue(sortValue) &&
        element.querySelector("[data-product-grid-host] [data-product-item]")
      ) {
        applyProductSort(element);
        return;
      }

      loadVendorPage(element, vendorName, currentPageUrl);
    });
  }

  function setStatus(element, title, text) {
    var status = element.querySelector("[data-seller-status]");
    status.hidden = false;
    element.querySelector("[data-seller-status-title]").textContent = title;
    element.querySelector("[data-seller-status-text]").textContent = text;
  }

  function setError(element, title, text) {
    var errorBox = element.querySelector("[data-seller-error]");
    errorBox.hidden = false;
    element.querySelector("[data-seller-error-title]").textContent = title;
    element.querySelector("[data-seller-error-text]").textContent = text;
  }

  function hideSystemState(element) {
    element.querySelector("[data-seller-status]").hidden = true;
    element.querySelector("[data-seller-error]").hidden = true;
  }

  function initSellerProfile(element) {
    if (element.dataset.initialised === "true") {
      return;
    }

    element.dataset.initialised = "true";
    initialiseTabs(element);
    initialiseProductSort(element);

    var sellerHandle = getSellerHandle(
      window.location.search,
      element.dataset.defaultSellerHandle || ""
    );
    var localSellerDirectory = getLocalSellerDirectory(element);
    var localSellerEntry = localSellerDirectory[normalizeHandle(sellerHandle)] || null;
    var shopDomain = resolveShopDomain(element);
    var publicProfileApiBaseUrl = resolvePublicProfileApiBaseUrl(element);
    var publicSellerId = localSellerEntry
      ? normalizeWhitespace(localSellerEntry.sellerId || "")
      : "";

    function showResolvedProfile(entry) {
      var profileData = buildLocalProfileData(entry, element);
      renderProfile(element, profileData);
      element.dataset.currentVendorName = profileData.vendorName || "";
      initialisePagination(element);
      hideSystemState(element);
      element.querySelector("[data-seller-content]").hidden = false;
      activateTab(element, "seller-profile-products");
      return profileData;
    }

    if (!sellerHandle) {
      setStatus(
        element,
        "Seller Handle Belum Ditentukan",
        "Tambahkan seller handle di URL, misalnya ?my-roti-official-store, atau isi fallback handle di setting section."
      );
      return;
    }

    if (localSellerEntry) {
      var localProfileData = showResolvedProfile(localSellerEntry);

      if (localProfileData.vendorName) {
        loadVendorPage(element, localProfileData.vendorName);
      } else {
        var productStatusNode = element.querySelector("[data-product-status]");
        productStatusNode.classList.add("is-empty");
        productStatusNode.textContent =
          "Vendor seller belum dikonfigurasi untuk menampilkan produk.";
      }

      requestPublicSellerProfile(
        publicProfileApiBaseUrl,
        sellerHandle,
        publicSellerId
      )
        .then(function (publicPayload) {
          var mergedEntry = mergeSellerEntry(
            localSellerEntry,
            buildPublicProfileEntry(publicPayload)
          );
          showResolvedProfile(mergedEntry);
        })
        .catch(function () {
          // Keep local fallback if public API is unavailable.
        });

      return;
    }

    if (publicProfileApiBaseUrl) {
      setStatus(
        element,
        "Memuat Profil Seller",
        "Mengambil profil seller dinamis dari custom app dan menyiapkan grid produk native theme."
      );

      requestPublicSellerProfile(publicProfileApiBaseUrl, sellerHandle, "")
        .then(function (publicPayload) {
          var publicProfileData = showResolvedProfile(
            buildPublicProfileEntry(publicPayload)
          );

          if (publicProfileData.vendorName) {
            return loadVendorPage(element, publicProfileData.vendorName);
          }

          var productStatusNode = element.querySelector("[data-product-status]");
          productStatusNode.classList.add("is-empty");
          productStatusNode.textContent =
            "Vendor seller belum dikonfigurasi untuk menampilkan produk.";
          return null;
        })
        .catch(function () {
          if (!shopDomain) {
            hideSystemState(element);
            setError(
              element,
              "Profil Seller Tidak Dapat Dimuat",
              "Theme tidak menemukan public seller API maupun shop domain Webkul yang dibutuhkan."
            );
            return;
          }

          setStatus(
            element,
            "Memuat Profil Seller",
            "Mengambil profil seller dari Webkul storefront sebagai fallback."
          );

          var fallbackProfileRequest = createWebkulProfileUrl(shopDomain, sellerHandle);

          return requestJsonp(
            fallbackProfileRequest.url,
            fallbackProfileRequest.callbackName
          )
            .then(function (profileHtml) {
              if (profileHtml === "denied") {
                throw new Error("seller_profile_denied");
              }

              if (!profileHtml || profileHtml === "NA") {
                throw new Error("seller_not_found");
              }

              var profileData = buildProfileData(profileHtml, element);
              renderProfile(element, profileData);
              element.dataset.currentVendorName = profileData.vendorName || "";
              initialisePagination(element);
              hideSystemState(element);
              element.querySelector("[data-seller-content]").hidden = false;
              activateTab(element, "seller-profile-products");

              return loadVendorPage(element, profileData.vendorName);
            })
            .catch(function (error) {
              hideSystemState(element);
              setError(
                element,
                "Profil Seller Tidak Dapat Dimuat",
                error && error.message === "seller_not_found"
                  ? "Seller handle tidak ditemukan di data seller lokal theme, public seller API, maupun Webkul."
                  : error && error.message === "seller_profile_denied"
                    ? "Webkul mengembalikan Access Denied dan public seller API belum mengembalikan data seller ini."
                    : "Terjadi kendala saat mengambil data seller dari public seller API atau fallback Webkul."
              );
            });
        });

      return;
    }

    if (!shopDomain) {
      setError(
        element,
        "Shop Domain Tidak Tersedia",
        "Theme tidak menemukan permanent shop domain yang dibutuhkan untuk memanggil seller profile Webkul."
      );
      return;
    }

    setStatus(
      element,
      "Memuat Profil Seller",
      "Mengambil profil seller dari Webkul dan menyiapkan grid produk native theme."
    );

    var profileRequest = createWebkulProfileUrl(shopDomain, sellerHandle);

    requestJsonp(profileRequest.url, profileRequest.callbackName)
      .then(function (profileHtml) {
        if (profileHtml === "denied") {
          throw new Error("seller_profile_denied");
        }

        if (!profileHtml || profileHtml === "NA") {
          throw new Error("seller_not_found");
        }

        var profileData = buildProfileData(profileHtml, element);
        renderProfile(element, profileData);
        element.dataset.currentVendorName = profileData.vendorName || "";
        initialisePagination(element);
        hideSystemState(element);
        element.querySelector("[data-seller-content]").hidden = false;
        activateTab(element, "seller-profile-products");

        return loadVendorPage(element, profileData.vendorName);
      })
      .catch(function (error) {
        hideSystemState(element);
        setError(
          element,
          "Profil Seller Tidak Dapat Dimuat",
          error && error.message === "seller_not_found"
            ? "Seller handle tidak ditemukan di data seller lokal theme maupun Webkul. Tambahkan seller tersebut ke block Seller Data Override atau pastikan handle Webkul benar."
            : error && error.message === "seller_profile_denied"
              ? "Webkul mengembalikan Access Denied untuk seller profile shop ini dan seller tersebut belum ada di data seller lokal theme."
              : "Terjadi kendala saat mengambil data seller dari Webkul atau grid vendor Shopify."
        );
      });
  }

  function bootstrap() {
    document
      .querySelectorAll("[data-seller-profile-page]")
      .forEach(function (element) {
        initSellerProfile(element);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap);
  } else {
    bootstrap();
  }
})();
